import { RANGE_PICKER } from '@nocowanie/core/consts';
import { dateHelpers } from '@nocowanie/core/helpers';

import { LocationType, PageTypeEnum } from '@app/enums';
import { environment } from '@app/environments/environment';
import { AccommodationItemModel } from '@app/models/accommodation-item.model';
import { LocationDetailsModel } from '@app/models/location-details.model';
import { MarkerDataType } from '@app/models/map-marker.model';

export type ArrayFilterProperty =
    | 'propertyType'
    | 'amenities'
    | 'provision'
    | 'reservationFeatures';
export type ScalarFilterProperty = 'rating' | 'priceFrom' | 'priceTo' | 'beachDistance';
export type StringFilterProperty = 'onlineBooking';

export interface SearchGuests {
    adultsCount: number;
    childrenCount: number;
    childrenAges: number[];
    guestCount: number;
}

export interface SearchCriteria {
    location: string;
    checkInDate: string | null;
    checkOutDate: string | null;
    guests: SearchGuests;
    geoId?: string | null;
    locationType?: LocationType | null;
    flexDates?: number;
    debug?: number;
    oneAlgorithm?: number;
    indexVersion?: number;
    poiId?: number;
    listingType?: PageTypeEnum | null;
}

export interface SearchFilters {
    propertyType?: string[];
    amenities?: string[];
    rating?: number | null;
    priceFrom?: number | null;
    priceTo?: number | null;
    provision?: string[];
    reservationFeatures?: string[];
    // Legacy parameters for back navigation to listing page
    sort?: string | null;
    onlineBooking?: string | null;
    beachDistance?: number | null;
}

export interface BaseSearchState {
    isFiltersContentVisible: boolean;
    searchCriteria: SearchCriteria;
    filters: SearchFilters;
    campaignListingId?: string;
    page: number;
    meta: {
        isLoading: boolean;
        hasSearchChanged: boolean;
        hasGeoChanged: boolean;
        lastSearchTimestamp: number | null;
    };
}

export interface MapSearchState {
    isMapLoaded: boolean;
    mapData: {
        accommodations?: MarkerDataType[];
        locationDetails: LocationDetailsModel | null;
        isLoadingAccommodations: boolean;
        accommodationsError: string | null;
        selectedAccommodation: AccommodationItemModel | null;
        realtimeBookingModelAccommodationsCount: number;
    };
}

export const defaultSearchCriteria: SearchCriteria = {
    location: '',
    checkInDate: dateHelpers.format(dateHelpers.defaultCheckInDate(), RANGE_PICKER.DATE_FORMAT),
    checkOutDate: dateHelpers.format(dateHelpers.defaultCheckOutDate(), RANGE_PICKER.DATE_FORMAT),
    guests: {
        adultsCount: 2,
        childrenCount: 0,
        childrenAges: [],
        guestCount: 2,
    },
    geoId: null,
    locationType: null,
    flexDates: environment.DEFAULT_FLEX_DATES,
};

export const defaultSearchFilters: SearchFilters = {
    rating: null,
    priceFrom: null,
    priceTo: null,
    beachDistance: null,
    propertyType: [],
    amenities: [],
    provision: [],
    reservationFeatures: [],
    sort: null,
    onlineBooking: null,
};

export const defaultMapData = {
    accommodations: undefined,
    realtimeBookingModelAccommodationsCount: 0,
    locationDetails: null,
    isLoadingAccommodations: false,
    accommodationsError: null,
    selectedAccommodation: null,
};
